import { render, staticRenderFns } from "./ReportingProfileView.vue?vue&type=template&id=c66a049c&"
import script from "./ReportingProfileView.vue?vue&type=script&lang=js&"
export * from "./ReportingProfileView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports